import React, { FC } from 'react';
import { Icon } from '../Icon';
import { Box, Center } from '@chakra-ui/react';
import { CoreLabelProps } from './types';

export type Props = {
  label: CoreLabelProps;
};

export const Label: FC<Props> = ({ label }) => {
  /**
   * DOM
   */
  return (
    <Center as="span" display="inline-flex" data-object-type="core-label" data-attribute={label.type}>
      {label.type === 'iconOnlyLabel' && (
        <Box as="span" mx={2}>
          <Icon {...label.options.icon} />
        </Box>
      )}
      {label.type === 'iconLeft' && (
        <Box as="span" mr={2}>
          <Icon {...label.options.icon} />
        </Box>
      )}
      {(label.type === 'textOnlyLabel' || label.type === 'iconLeft' || label.type === 'iconRight') &&
        label.options.text}
      {label.type === 'iconRight' && (
        <Box as="span" ml={2}>
          <Icon {...label.options.icon} />
        </Box>
      )}
    </Center>
  );
};
